import React, { useEffect } from "react";
import styled from "styled-components/macro";
import BeehiveImg from "lib/images/beehive.png";
import { PrimaryButton, ButtonText } from "@loanbossinc/component-library";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2em 10em;
  max-width: ${(({ maxWidth }) => maxWidth ?? "1920px")};
  width: 100%;
`;

const IntroWrapper = styled.div`
  width: 100%:
`;

const StyledButtonText = styled(ButtonText)`&& {
  && > span {
    gap: 0.5em;
  }
}`;

const IntroSectionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const Image = styled.img`
  object-fit: contain;
`;

const GuidingText = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2em;
  max-width: 75%;
`;

const GreetingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.25em;
`;

const ContextText = styled.p`
  font-size: 16px;
  font-weight: 400;
  width: 75%;
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 235px;
`;

const MCLHeader = ({ maxWidth, history, handleSaveListClicked }) => {
  const buttonStyles = { width: "235px", borderRadius: "8px" };

  return (
    <Container maxWidth={maxWidth}>
      <IntroWrapper>
        <StyledButtonText label="Back to campaigns" iconName="arrow_forward" onClick={() => history.push("/campaigns", { from: history.location.pathname })} reverse />
        <IntroSectionWrapper>
          <Image src={BeehiveImg} />
          <GuidingText>
            <GreetingWrapper>Configure your master contact list</GreetingWrapper>
            <ContextText>Select to exclude contacts from this list that you do not want to ever receive emails. This will apply to all emails that you create.</ContextText>
          </GuidingText>
          <ButtonsContainer>
            <PrimaryButton
              label="Save List"
              style={buttonStyles}
              onClick={handleSaveListClicked}
            />
          </ButtonsContainer>
        </IntroSectionWrapper>
      </IntroWrapper>
    </Container>
  );
};

export default MCLHeader;
